export default {
  methods : {
    $asset(assetid){
      const dict=this.$store.getters['assets/dict'];
      if(!dict.hasOwnProperty(assetid)){
        console.error('Asset '+assetid+' not found!');
        return null;
      }
      return dict[assetid].url;
    },
    $ta(textassetid){
      if(!textassetid){
        return null;
      }
        return this.$store.state.textassets.data[textassetid] || `[${textassetid}]`;
    },
    $t_num(number){
      if(this.$i18n.locale!=='ar' && this.$i18n.locale!=='fa'){
        return number;
      }else if(this.$i18n.locale==='ar'){
        return (number+'').toArDigits();
      }else if(this.$i18n.locale==='fa'){
        return (number+'').toFaDigits();
      }
    }
  }
}